module.exports = __webpack_public_path__ + "img/matlagning.6f4152c1.jpg";